import { render, staticRenderFns } from "./DealsHeader.vue?vue&type=template&id=35c76b89&"
import script from "./DealsHeader.vue?vue&type=script&lang=js&"
export * from "./DealsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports